export const avigilonAltaIdTooltipText =
  'This is a unique identifier associated with your SSO app configuration and may be required the first time you use SSO to sign in. You can get this from your Avigilon Alta admin. ';
